import { Box } from "@mui/material";
import { TabPanel } from "../../controls";
import { SchedulerTabPage } from "./SchedulerTabPage";
import { SystemLogTabPage } from "./SystemLogTabPage";

export const HomePage = () => {
  return (
    <Box>
      <TabPanel name="home" items={[
        { label: "SCHEDULER", children: <SchedulerTabPage /> },
        { label: "SYSTEM LOG", children: <SystemLogTabPage /> },
      ]}  />
    </Box>
  );
};
